export default function sponsors(axios: any) {
  const getSponsors = async () => {
    const result = await axios.get('/sponsors');
    try {
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      console.error('[/api/sponsor.ts] getSponsors error');
    }
    return null;
  };

  const createSponsor = async (payload: any) => {
    const result = await axios.post('/sponsors', {
      ...payload,
    });
    try {
      if (result.status === 200) {
        return result.data.sponsor;
      }
    } catch (error) {
      console.error('[/api/sponsor.ts] createSponsor error');
    }
    return null;
  };

  const updateSponsor = async (id: number, payload: any) => {
    const result = await axios.put(`/sponsors/${id}`, {
      ...payload,
    });
    try {
      if (result.status === 200) {
        return result.data.sponsor;
      }
    } catch (error) {
      console.error('[/api/sponsor.ts] updateSponsor error');
    }
    return null;
  };

  const deleteSponsors = async (ids: number[]) => {
    const result = await axios.post('/sponsors/delete', {
      ids,
    });
    try {
      if (result.status === 200) {
        return result.data.sponsor;
      }
    } catch (error) {
      console.error('[/api/sponsor.ts] deleteSponsors error');
    }
    return null;
  };

  return {
    getSponsors,
    createSponsor,
    updateSponsor,
    deleteSponsors,
  };
}
